<template>
    <div class="not-found-wrap">
        <div class="not-found">
            <h1>404</h1>
            <h3>Siden blev ikke fundet</h3>
            <router-link :to="to" class="return-button">Klik her for at gå til forsiden</router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import url("https://fonts.googleapis.com/css?family=Roboto:300,400,500,700");

    $text: #ffffff;
    $background: #F1A1D9;

    .not-found-wrap{
        position:absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:$background;
        z-index:999;
        display:flex;
        align-items: center;
        justify-content: center;
        text-align:center;
        font-family: "Roboto", sans-serif;

        .return-button{
            color:$text;
            border-radius:8px;
            border: 1px solid $text;
            padding:10px;
            cursor: pointer;

            transition: 200ms ease-in-out;

            &:hover{
                border-color: darken($text, 10%);
                color: darken($text, 10%);
            }
        }
    }
    h1{
        font-size: 60pt;
        font-weight: 500;
        letter-spacing: 10px;
        color:$text;
    }
    h3{
        color:$text;
        margin-bottom:20px;
    }
</style>

<script>
export default {
    name: "PageNotFound404",
    computed: {
        to(){
            const route = { name : 'home'}
            return route
        }
    },
    metaInfo: {
        meta : [
            { name: 'robots', content: "noindex" }
        ]
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/PageNotFound404.vue